import "../shared-components/ViewFragments/ProjectEspecialSingle/style.less";

import React from "react";
import { decodeHashUrl } from "../shared-components/Utils/Functions";
import { withApollo } from "../lib/apollo3";
import { withAuth } from "../lib/auth";
import { withContext } from "../lib/context";
import { withGlobalComponents } from "../shared-components/ViewFragments/GlobalComponents/web";
import { withTranslation } from "../shared-components/i18n";
import { ContactModalProvider } from "shared-components/Contexts/ContactModal/context";
import { ProjectSpecial } from "src/Components/ProjectSpecial/ProjectSpecial";
import { PropertyDataProvider } from "src/contexts/PropertyData/PropertyDataProvider";
import { fetchSearchResults } from "src/services/search";
import { QUERY_PROJECT_DETAILS } from "shared-components/GQL";
import { PropertyEmptyState } from "shared-components/Components/Property/EmptyState/web";

// ProjectEspecialSingle
const projectEspecialSingle = props => {
	
	if (props.showEmptyState) {
		return <PropertyEmptyState data={props.data}/>;
	}

	const data = props.data;

	return (
		<PropertyDataProvider initialListing={data}>
			<ContactModalProvider>
				<ProjectSpecial {...props} data={data} />

				{/* <RTBhouse page={"offer"} data={props.__PROJECT__ID__} /> */}
			</ContactModalProvider>
		</PropertyDataProvider>
	);
};

projectEspecialSingle.getInitialProps = async function ({ apolloClient, req, res, query }) {
	let project = await decodeHashUrl(query.hashed);
	const { main_domain } = project.configs;
	const __PROJECT__ID__ = project.id;
	const payload = {
		rows: 1,
		params: {
			id: __PROJECT__ID__,
		},
		page: 1,
		source: 10,
	};

	const fetchResult = await fetchSearchResults(payload, main_domain)
	const data = fetchResult?.searchFast?.data[0];

	if(project.status === "deactivated") {
		data.active = false;
	}
	let showEmptyState = false;

	if (!data) {
		// Si data es undefined, redirige a 404
		if (res) {

			try {
				const { data: gqlData } = await apolloClient.query({
					query: QUERY_PROJECT_DETAILS,
					variables: { id: __PROJECT__ID__ },
				});
				
				const gqlProjects = gqlData?.project;

				let gqlProjectsData = {
					...gqlProjects,
					title: gqlProjects?.title + " [No disponible]",
                    inactiveSimilarInfo : { 
						status: project.status,
						operation_type_id: project.operation_type_id,
						property_type_id: project.property_type_id,
						price: project.price,
						neighborhood_id: project.neighborhood_id,
						city_id: project.city_id
					}
				};

				if (!gqlProjects?.owner?.active) {
					throw new Error('owner desactivate');
				}

				if (gqlProjects?.active) {
					res.statusCode = 202;
					showEmptyState = true;
				}

				return {
					__PROJECT__ID__,
					data: gqlProjectsData,
					showEmptyState
				};

			} catch (e) {
				res.statusCode = 404;
			}

			return {
				__PROJECT__ID__,
				data: null,
				showEmptyState
			};
		} else {
			throw new Error("Data not found");
		}
	}

	return {
		__PROJECT__ID__,
		UrlToBack: query.location || -1,
		DummyContextInitialState: { count: 23 },
		ConfigContextInitialState: project?.configs,
		data,
		showEmptyState
	};
};

export default withApollo(
	withContext(withTranslation(withAuth(withGlobalComponents(projectEspecialSingle))), {
		withDummyContext: false,
		withFiltersContext: true,
		withConfigContext: true,
		withThemeContext: true,
	})
);

